import { ECompletionYearType } from 'shared/common/packages/JsonQuery/types';

import { AVAILABLE_COMPLETION_YEAR_TYPES } from '../../../constants/availableCompletionYearTypes';

interface ICompletionYearOption {
  label: string;
  value: ECompletionYearType | null;
}

export function getCompletionYearOptions(yearOffset: number): ICompletionYearOption[] {
  const yearOptions = AVAILABLE_COMPLETION_YEAR_TYPES.map(value => ({
    label: String(yearOffset + (value as number)),
    value,
  }));

  return [
    { label: 'Неважно', value: null },
    { label: 'Сдан', value: ECompletionYearType.HandedOver },
    ...yearOptions,
    { label: 'Позднее', value: ECompletionYearType.Later },
  ];
}
